<div class="row my-row justify-content-md-center" style="padding-top: 40px;">
    <div class="col-sm-auto">
        <div class="card" style="width: 70rem; border-radius: 20px; margin: 20px;">
            <div class="card-header text-center">
                <h1>{{ "CGU.TITLE" | translate }}</h1>
            </div>
            <div class="row my-row no-gutters">
                <div class="col-sm-10">
                    <div class="card-body">
                        <app-error [error_message]="errorMessage" [error_type]="errorType"></app-error>
                        <div class="mt-2" *ngIf="this.cguList">
                            <p>{{ "CGU.INFO" | translate }}</p>
                            <p>{{ "CGU.INFO2" | translate }}</p>
                            <ul>
                                <li *ngFor="let cgu of this.cguList | keyvalue">
                                    <a class="nav-link" (click)="downloadFile(cgu.key)">
                                        {{ "CGU.DOWNLOAD" | translate }} {{ cgu.value }}
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div>
                            <button type="button" class="btn btn-primary" (click)="validateCgu()">
                                {{ "BUTTONS.VALIDATE-CGU" | translate }}
                            </button>
                            <button type="button" class="btn btn-danger ml-1" (click)="refuseCgu()">
                                {{ "BUTTONS.REFUSE-CGU" | translate }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
